export const JUMBO_TABLES = {
  LIFELINE_EVENTS: 'lifeline_events',
};

export const isLogging = () => {
  return false;
  return process.env.NODE_ENV === 'production';
};

const jumbo = {
  sendPageView: (...args) => {
    console.log(args);
  },
  sendToJumbo: (...args) => {
    console.log(args);
  },
  setParams: (...args) => {
    console.log(args);
  },
};

const dashboardMode = window.dashboard?.mode ?? 'lifeline';

export const sendEventToJumbo = ({
  eventName,
  orderId,
  customerId,
  responseMeta,
  requestMeta,
  reponseCode,
}) => {
  if (!isLogging()) return;

  const jumbo_data = {
    ename: eventName,
    order_id: Number(orderId) || 0,
    customer_id: String(customerId) || '',
    source: String(dashboardMode) || '',
    response_meta: responseMeta || {},
    request_meta: requestMeta || {},
    reponse_code: reponseCode || 0,
  };

  jumbo.sendToJumbo(JUMBO_TABLES.LIFELINE_EVENTS, jumbo_data);
};

export const sendPageViewToJumbo = (pageUrl) => {
  if (!isLogging()) return;
  jumbo.sendPageView(pageUrl);
};

export const sendParamsToJumbo = (params) => {
  if (!isLogging()) return;
  jumbo.setParams(params);
};
